<rappider-list-grid [config]="PROJECT_MEMBERS_CONFIG"
                    [data]="projectMembers"
                    [loading]="!projectMembers"
                    (columnActionClick)="onItemClick($event)"></rappider-list-grid>
